import React, { useState, useEffect} from "react";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import LibraryCategoryList from "views/pages/librarycategory/LibraryCategoryList";
import AddLibraryCategory from "views/pages/librarycategory/AddLibraryCategory";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const LibraryCategory = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [libraryCateList, setLibraryCateList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState(0);
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const location = useLocation();
  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteLibraryCategory)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = libraryCateList.filter((o) => o.id !== id);
            setLibraryCateList(filter);
            fetchLibraryCategory();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setSearchText("");
    setType(type);
    if (id) {
      const findList = libraryCateList.find((o) => o.id === id);

      setUpdateData(findList);
    }

    setOpenModal(!openModal);
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const librarycate = Utility.getUserData({
        datastore:userData,
        activePath: location.pathname,
      });

      setPermission(librarycate[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);

  useEffect(() => {
    fetchLibraryCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageNumber, pageSize]);

  const fetchLibraryCategory = () => {
    Loader.isLoading(true);
    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "ASC",
      searchText: searchText,
    };
    APICall("post", payload, EndPoints.getLibraryCategory)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setLibraryCateList(results);
          setTotalRecord(totalCount);
        } else {
          setLibraryCateList([]);
        }
       
      })
      .catch((error) => {
        
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitLibraryCategory = () => {
    fetchLibraryCategory();
  };

  const updateLibraryCategory = (data) => {
    const updatedData = libraryCateList.map((x) => {
      if (x.id === data.id) {
        return {
          ...x,
          cat_name: data.cat_name,
        };
      }
      return x;
    });
    setLibraryCateList(updatedData);
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Library Category Manage
          </Typography>
        }
      />
       {((permission.view && role === "2") || role === "1") && (
      <Grid item xs={12}>
        <LibraryCategoryList
          handleDeleteModal={handleDeleteModal}
          deleteOpen={deleteOpen}
          handleOpen={handleOpen}
          libraryCateList={libraryCateList}
          pageSize={pageSize}
          setPageSize={setPageSize}
          searchText={searchText}
          setSearchText={setSearchText}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          totalRecord={totalRecord}
          permission={permission}
          role={role}
        />
      </Grid>
       )}
      <AddLibraryCategory
        open={openModal}
        toggle={handleOpen}
        type={type}
        heading={
          type === "add" ? "Add Library Category" : "Update Library Category"
        }
        onSubmitCategory={submitLibraryCategory}
        onHandleUpdate={updateLibraryCategory}
        updateData={updateData}
        permission={permission}
        role={role}
      />
    </Grid>
  );
};

export default LibraryCategory;
